import { render, staticRenderFns } from "./LoopingVideo.vue?vue&type=template&id=1865e109&"
import script from "./LoopingVideo.vue?vue&type=script&lang=ts&"
export * from "./LoopingVideo.vue?vue&type=script&lang=ts&"
import style0 from "./LoopingVideo.vue?vue&type=style&index=0&id=1865e109&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports